import { graphql } from '@/gql';
import type { PrintStoresMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const printStores = async ({
  mailing,
  email,
  accessibleEmail,
  userId,
  firstName,
  printList,
  stores,
}: PrintStoresMutationVariables) => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation printStores(
        $mailing: MailingInputType
        $email: String
        $accessibleEmail: Boolean
        $userId: String
        $firstName: String!
        $printList: Boolean!
        $stores: [StoreGroupInput!]!
      ) {
        printStores(
          mailing: $mailing
          email: $email
          accessibleEmail: $accessibleEmail
          userId: $userId
          firstName: $firstName
          printList: $printList
          stores: $stores
        )
      }
    `),
    variables: {
      mailing,
      email,
      accessibleEmail,
      userId,
      firstName,
      printList,
      stores,
    },
  });

  return response.data?.printStores ?? false;
};
